/** Is every gate currently accepting every colour? */
export function isRainbowActive(state) {
    return state.rainbowSinceMove !== undefined;
}
/**
 * The exit options every caller resolving a move on THIS board must pass.
 *
 * Exported as a function rather than left to each call site to assemble, for the
 * reason AUD-010 exists: two callers composing the same primitives differently
 * is the same defect as two implementations, and this is precisely the predicate
 * that diverged last time.
 */
export function rainbowExitOptions(state) {
    return isRainbowActive(state) ? { rainbow: true } : {};
}
/** Turn every gate rainbow, from this move onward. */
export function activateRainbow(state) {
    return { ...state, rainbowSinceMove: state.moveCount };
}
/**
 * A block went through a gate — the rainbow is spent.
 *
 * Returns the state unchanged when it was not active, so the caller can call it
 * on every exit without asking first.
 */
export function endRainbow(state) {
    if (!isRainbowActive(state))
        return state;
    const next = { ...state };
    delete next.rainbowSinceMove;
    return next;
}
/**
 * Moves spent while the rainbow was open, or 0 when it is not active.
 *
 * Clamped at 0 rather than trusted: an edited save could carry a
 * `rainbowSinceMove` above the current `moveCount`, and a negative duration on
 * an analytics payload is worse than a wrong one — it is unfilterable.
 */
export function rainbowMovesOpen(state) {
    if (state.rainbowSinceMove === undefined)
        return 0;
    return Math.max(0, state.moveCount - state.rainbowSinceMove);
}
/**
 * Module 90 (D3) — did this exit USE Wild Gates? True only when Wild Gates was
 * open and the block left through a coloured gate of a different colour: the
 * one exit it could not have made without it. That exit is what charges the
 * player and closes the mode. A same-colour or colourless-gate exit does
 * neither.
 *
 * Asked by the board at the exit instant and by the plugin's programmatic path
 * with the same arguments, so the two can never disagree (AUD-010). Pair it
 * with `exitingGate`, which prefers the block's own gate when both fit.
 */
export function wildSpentBy(gate, block, opts) {
    if (!opts.rainbow || !gate)
        return false;
    return gate.colorId !== undefined && gate.colorId !== block.colorId;
}
